import { c as _c } from "react/compiler-runtime";
import type { Organization } from '@onefootprint/request-types/dashboard';
import { Dropdown, LinkButton } from '@onefootprint/ui';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import TenantItem from './components/tenant-item';
type TenantsListProps = {
  tenants: Organization[];
  currTenantId: string;
  assumedTenant?: {
    id: string;
    name: string;
  };
  isSwitchingTenant?: boolean;
  onSelect?: (tenantId: string) => void;
};
const NUM_TENANTS_IN_DROPDOWN = 5;
const TenantsList = t0 => {
  const $ = _c(33);
  const {
    tenants,
    currTenantId,
    assumedTenant,
    isSwitchingTenant,
    onSelect
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "components.privateLayout.nav.tenantsList"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("common", t1);
  const [shouldShowAllTenants, setShouldShowAllTenants] = useState(false);
  let t2;
  if ($[1] !== shouldShowAllTenants || $[2] !== tenants) {
    t2 = shouldShowAllTenants ? tenants : tenants.slice(0, NUM_TENANTS_IN_DROPDOWN);
    $[1] = shouldShowAllTenants;
    $[2] = tenants;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const displayList = t2;
  let t3;
  if ($[4] !== isSwitchingTenant || $[5] !== onSelect) {
    t3 = tenantId => {
      if (isSwitchingTenant) {
        return;
      }
      onSelect?.(tenantId);
    };
    $[4] = isSwitchingTenant;
    $[5] = onSelect;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const handleClick = t3;
  let t4;
  if ($[7] !== shouldShowAllTenants) {
    t4 = () => {
      setShouldShowAllTenants(!shouldShowAllTenants);
    };
    $[7] = shouldShowAllTenants;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const handleToggleAll = t4;
  let t5;
  if ($[9] !== t) {
    t5 = t(_temp);
    $[9] = t;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t5) {
    t6 = <Dropdown.GroupTitle className="flex px-2 pt-2 pb-1 text-tertiary text-caption-3">{t5}</Dropdown.GroupTitle>;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== assumedTenant) {
    t7 = assumedTenant && <Dropdown.Item variant="radio" value={assumedTenant.id} onSelect={_temp2} aria-label={assumedTenant.name} className="text-body-3 !px-2 !h-8 !gap-2 cursor-default hover:bg-transparent!">{assumedTenant.name}</Dropdown.Item>;
    $[13] = assumedTenant;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== displayList || $[16] !== handleClick || $[17] !== isSwitchingTenant) {
    let t9;
    if ($[19] !== handleClick || $[20] !== isSwitchingTenant) {
      t9 = tenant => <TenantItem key={tenant.id} tenant={tenant} onClick={() => handleClick(tenant.id)} disabled={isSwitchingTenant} aria-label={tenant.name}>{tenant.name}</TenantItem>;
      $[19] = handleClick;
      $[20] = isSwitchingTenant;
      $[21] = t9;
    } else {
      t9 = $[21];
    }
    t8 = displayList.map(t9);
    $[15] = displayList;
    $[16] = handleClick;
    $[17] = isSwitchingTenant;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[22] !== handleToggleAll || $[23] !== shouldShowAllTenants || $[24] !== t || $[25] !== tenants.length) {
    t9 = tenants.length > NUM_TENANTS_IN_DROPDOWN && <LinkButton variant="label-3" className="px-2 h-8" onClick={handleToggleAll}>{t($_0 => shouldShowAllTenants ? $_0.showLess : $_0.showAll)}</LinkButton>;
    $[22] = handleToggleAll;
    $[23] = shouldShowAllTenants;
    $[24] = t;
    $[25] = tenants.length;
    $[26] = t9;
  } else {
    t9 = $[26];
  }
  let t10;
  if ($[27] !== currTenantId || $[28] !== t6 || $[29] !== t7 || $[30] !== t8 || $[31] !== t9) {
    t10 = <Dropdown.RadioGroup value={currTenantId} className="p-1 flex flex-col gap-0.5">{t6}{t7}{t8}{t9}</Dropdown.RadioGroup>;
    $[27] = currTenantId;
    $[28] = t6;
    $[29] = t7;
    $[30] = t8;
    $[31] = t9;
    $[32] = t10;
  } else {
    t10 = $[32];
  }
  return t10;
};
export default TenantsList;
function _temp($) {
  return $.title;
}
function _temp2(event) {
  return event.preventDefault();
}